






































































import { mapGetters } from 'vuex';

import {
  getRestreamConfiguration,
  updateRestreamConfiguration
} from '@/api/CopyStake/Settings';
import {
  mapRestreamPlatformName,
  ERestreamPlatform,
  TRestreamConfig,
  TCopyStakeSettingsRestreamResponse,
  TCopyStakeSettingsRestreamPayload,
  ValidationRules
} from '@/api/schema';

import { errorToastMessage } from '@/helpers/errorToastMessage';
import { cloneDeep, isEqual } from 'lodash';
import type { AxiosError } from 'axios';
import * as vr from '@/helpers/validation';

const getDefaultRestreamConfig = (): TRestreamConfig[] =>
  (Object.values(ERestreamPlatform) as ERestreamPlatform[]).map((p) => ({
    platform: p,
    rtmpUrl: '',
    streamKey: '',
    enabled: false
  }));

export default {
  name: 'CopyStakeSettingsRestream',
  data(): any {
    return {
      mapRestreamPlatformName,

      restreamPlatformsConfigSavedData: getDefaultRestreamConfig(),
      restreamPlatformsConfig: getDefaultRestreamConfig(),
      restreamShowKey: {},

      isLoading: false,
      formValid: false
    };
  },
  props: {
    title: {
      type: String,
      default: (): string => ''
    }
  },
  computed: {
    ...mapGetters('Onboarding', ['operatorId']),

    platformIcons(): Record<string, string> {
      return {
        [ERestreamPlatform.TWITCH]: require('@/assets/images/icons/socialRestream/twitch.svg'),
        [ERestreamPlatform.KICK]: require('@/assets/images/icons/socialRestream/kick.svg'),
        [ERestreamPlatform.YOUTUBE]: require('@/assets/images/icons/socialRestream/youtube.svg'),
        [ERestreamPlatform.FACEBOOK]: require('@/assets/images/icons/socialRestream/facebook.svg')
      };
    },

    canEdit(): boolean {
      return this.$role.can.update('copy_stake streamers');
    },

    restreamConfigChanged(): boolean {
      return !isEqual(
        this.restreamPlatformsConfig,
        this.restreamPlatformsConfigSavedData
      );
    },
    valueCanBeSaved(): boolean {
      return this.formValid && this.restreamConfigChanged;
    },

    rules(): ValidationRules {
      return {
        rtmpUrl: [(v) => vr.required(v, 'TRMP URL')],
        streamKey: [(v) => vr.required(v, 'Stream Key')]
      };
    }
  },
  watch: {
    operatorId: {
      handler: 'getConfiguration',
      immediate: true
    }
  },
  methods: {
    toggleVisibleRestreamKey(platform: ERestreamPlatform): void {
      this.$set(
        this.restreamShowKey,
        platform,
        !this.restreamShowKey[platform]
      );
    },
    mergeRestreamConfig(
      incomingPlatforms: TRestreamConfig[] = []
    ): TRestreamConfig[] {
      return this.restreamPlatformsConfig.map(
        (defaultCfg: TRestreamConfig) => {
          const existing = incomingPlatforms.find(
            (cfg) => cfg.platform === defaultCfg.platform
          );

          return existing ? { ...defaultCfg, ...existing } : defaultCfg;
        }
      );
    },

    parseSettingsData(data: TCopyStakeSettingsRestreamResponse): void {
      const parsedData = this.mergeRestreamConfig(data?.platforms);

      this.restreamPlatformsConfigSavedData = cloneDeep(parsedData);
      this.restreamPlatformsConfig = cloneDeep(parsedData);
    },

    async getConfiguration(): Promise<void> {
      if (!this.operatorId) {
        return;
      }

      this.isLoading = true;

      getRestreamConfiguration()
        .then((data: TCopyStakeSettingsRestreamResponse) => {
          this.parseSettingsData(data);
        })
        .catch((err: AxiosError): void => {
          errorToastMessage(err);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    async updateConfiguration(): Promise<void> {
      const isFormValid = await this.$refs.form.validate();
      if (!isFormValid) return;

      this.isLoading = true;

      const payload: TCopyStakeSettingsRestreamPayload = {
        platforms: this.restreamPlatformsConfig
      };

      await updateRestreamConfiguration(payload)
        .then((data: TCopyStakeSettingsRestreamResponse) => {
          this.parseSettingsData(data);

          this.$toast.success('Restream settings was successfully updated!');
        })
        .catch((err: AxiosError): void => {
          errorToastMessage(err);
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  }
};
